import React, { useEffect } from 'react';
import { Helmet } from "react-helmet";
import AvailableOn from '../AvailableOn/AvailableOn';
import './TermConditions.css';

const TermConditions = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Kuku Namkeen | Terms & Conditions</title>
                <link rel="canonical" href="https://kukunamkeen.in/terms-conditions" />
            </Helmet>

            {/* Page Header Banner */}
            <section className="term-header-title">
                <div className="max-w-6xl mx-auto px-4">
                    <h1>TERMS & CONDITIONS</h1>
                </div>
            </section>
            <img
                src="/Image/border-bottom-title.png"
                className="w-full header-title-image"
                alt=""
            />

            {/* Terms & Conditions Content */}
            <section className="policies-section">
                <div className="max-w-6xl mx-auto px-4 lg:px-8">
                    
                    <div className="block-margin">
                        <h3 className="heading-title">Introduction</h3>
                        <p>
                            Kuku Namkeen and/or its affiliates ("Kuku Namkeen") provide website features and other products and
                            services to you when you visit or shop at www.kukunamkeen.in, to use our products or services. Kuku
                            Namkeen provides the services subject to the following terms and conditions.
                        </p>
                        <p>
                            By using Products or Services through www.kukunamkeen.in, you are unconditionally and out of free
                            will agreeing to the conditions below:
                        </p>
                    </div>

                    <div className="block-margin">
                        <h3 className="heading-title">Outlet Orders</h3>
                        <p>
                            When placing an outlet order for Dine-in or Takeaway, it is the customer’s responsibility to ensure
                            that they are at the store when placing the order to ensure service of fresh food.
                        </p>
                    </div>

                    <div className="block-margin">
                        <h3 className="heading-title">Privacy</h3>
                        <p>
                            Please review our Privacy Policy, which also governs your use of all information (whether personal or
                            public).
                        </p>
                    </div>

                    <div className="block-margin">
                        <h3 className="heading-title">Electronic &amp; Communications</h3>
                        <p>
                            When you use any of Kuku Namkeen services, or reach us via email, you are establishing a
                            communication with us, thereby confirming your consent to receive communications from us
                            electronically. We will communicate with you by e-mail / text message / WhatsApp. You agree that all
                            agreements, notices, disclosures and other communications that we provide to you electronically
                            satisfy any legal requirement that such communications be in writing.
                        </p>
                    </div>

                    <div className="block-margin">
                        <h3 className="heading-title">Copyright</h3>
                        <p>
                            All content included in or made available through any of the availed service, such as text, graphics,
                            logos, button icons, images, audio clips and data compilations is the property of Kuku Namkeen or
                            its content suppliers and shall be protected and governed by laws of the land in India. Any
                            unwarranted copy of content is strictly prohibited and illegal.
                        </p>
                    </div>

                    <div className="block-margin">
                        <h3 className="heading-title">Trademarks</h3>
                        <p>
                            In addition, graphics, logos, page headers, button icons, scripts, and service names included in or
                            made available through any service are trademarks or service mark of Kuku Namkeen or its affiliates
                            or its content suppliers does not get any right for copying or using the same by availing the
                            services.
                        </p>
                    </div>

                    <div className="block-margin">
                        <h3 className="heading-title">Your Login Account</h3>
                        <p>
                            Upon registering yourself with the portal, you are responsible for maintaining the confidentiality of
                            your account information and password and for restricting access to your computer. You agree to
                            accept responsibility of authenticity of the information and for all activities that occur under
                            your account or password. However, Kuku Namkeen reserves the right to refuse service, terminate
                            accounts, remove or edit content, or cancel orders in its sole discretion with no damage or demure
                            payable to you.
                        </p>
                    </div>

                    <div className="block-margin">
                        <h3 className="heading-title">Risk of Loss</h3>
                        <p>
                            All items purchased through electronic mode through this website are made pursuant to a shipment
                            contract. This means that the risk of loss and title for such items pass to you upon our delivery to
                            the carrier (shipping partner) for dispatch.
                        </p>
                    </div>

                    <div className="block-margin reveal">
                        <h3 className="heading-title">Disclaimer of warranties &amp; limitation of liability.</h3>
                        <p>
                            The Kuku Namkeen services and all information, content, materials, products (including software) and
                            other services included on or otherwise made available to you through the website services are
                            provided by Kuku Namkeen on an "as is" and "as available" basis, unless otherwise specified in
                            writing. Kuku Namkeen makes no representations or warranties of any kind, express or implied, as to
                            the operation of the Kuku Namkeen services, or the information, content, materials, products
                            (including software) or other services included on or otherwise made available to you through the
                            Kuku Namkeen services, unless otherwise specified in writing. You explicitly agree that your use of
                            the Kuku Namkeen services is at your sole risk.
                        </p>
                        <p>
                            To the full extent permissible by applicable law, Kuku Namkeen disclaims all warranties, express or
                            implied, including, but not limited to, implied warranties of merchantability and fitness for a
                            particular purpose. Kuku Namkeen does not warrant that the Kuku Namkeen services, information,
                            content, materials, products (including software) or other services included on or otherwise made
                            available to you through the Kuku Namkeen services, Kuku Namkeen servers or electronic
                            communications sent from Kuku Namkeen are free of viruses or other harmful components. Kuku Namkeen
                            will not be liable for any damages of any kind arising from the use of any Kuku Namkeen service, or
                            from any information, content, materials, products (including software) or other services included
                            on or otherwise made available to you through any Kuku Namkeen service, including, but not limited
                            to direct, indirect, incidental, punitive, and consequential damages, unless otherwise specified in
                            writing.
                        </p>
                    </div>
                </div>
            </section>

            {/* Available On */}
            <AvailableOn />
        </>
    );
}

export default TermConditions;
